import RadioComponent from './Radio';

export default RadioComponent;
